import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
      mode: "history",
    // mode: 'hash',
    base: process.env.BASE_URL,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return {x: 0, y: 0};
        }
    },
    routes: [
        {
            path: "/login",
            name: "login",
            component: () => import('@/views/user/login.vue')
        },
        {
            path: '/',
            component: () => import('@/layout/index.vue'),
            children: [
                { path: 'home', component: () => import('@/views/index/home.vue') },
                { path: 'funds/add', component: () => import('@/views/funds/add.vue') },
                { path: 'funds/withdraw', component: () => import('@/views/funds/withdraw.vue') },
                { path: 'payments', component: () => import('@/views/payments/index.vue') },
                { path: 'transfer-stablecoins', component: () => import('@/views/transfer-stablecoins/index.vue') },
                { path: 'cards', component: () => import('@/views/cards/usd.vue') },
                { path: 'activity', component: () => import('@/views/activity/index.vue') },
                { path: 'settings', component: () => import('@/views/settings/profile.vue') },
                { path: 'settings/profile', component: () => import('@/views/settings/profile.vue') },
                { path: 'settings/preferences', component: () => import('@/views/settings/preferences.vue') },
                { path: 'settings/verification', component: () => import('@/views/settings/verification.vue') },
                { path: 'settings/security', component: () => import('@/views/settings/security.vue') },
                { path: 'settings/payment-methods', component: () => import('@/views/settings/payment-methods.vue') },
                { path: 'settings/apps', component: () => import('@/views/settings/apps.vue') },
                { path: 'settings/limits', component: () => import('@/views/settings/limits.vue') },
                { path: 'invite', component: () => import('@/views/invite/index.vue') },
                { path: 'earn', component: () => import('@/views/earn/profile.vue') },
                { path: 'peer-transfers/available', component: () => import('@/views/peer-transfers/available.vue') },
                { path: 'funds/add/virtual-accounts', component: () => import('@/views/funds/virtual-accounts/index.vue') },
                { path: 'funds/add/virtual-accounts/USD', component: () => import('@/views/funds/virtual-accounts/USD.vue') },
                { path: 'funds/add/virtual-accounts/EUR', component: () => import('@/views/funds/virtual-accounts/EUR.vue') },
                { path: 'funds/add/virtual-accounts/COP', component: () => import('@/views/funds/virtual-accounts/COP.vue') },
                { path: 'funds/add/virtual-accounts/MXN', component: () => import('@/views/funds/virtual-accounts/MXN.vue') },
                { path: 'operations/:id', component: () => import('@/views/operations/index.vue') },
                { path: '', redirect: '/home' },
            ]
        },
    ]
});
